import React from 'react'
import Swal from 'sweetalert2'
import { PopUpContainer, PopUpContent, PopUpHeader, PopUpParagraph, PopUpTitle } from './style'
import '../style.css'
import { renderToString } from 'react-dom/server'

export interface StartupProps {
  title: string
  message: string | JSX.Element
}

export const showStartupPopUp = ({ title, message }: StartupProps): void => {
  const content = (
    <PopUpContainer>
      <PopUpHeader>
        <PopUpTitle>{title}</PopUpTitle>
      </PopUpHeader>
      <PopUpContent>
        <PopUpParagraph>{message}</PopUpParagraph>
      </PopUpContent>
    </PopUpContainer>
  )

  Swal.fire({
    showCloseButton: true,
    showConfirmButton: false,
    allowOutsideClick: true,
    customClass: {
      popup: 'startup-modal',
      closeButton: 'startup-modal-close',
      container: 'startup-modal-container'
    },
    html: renderToString(content),
    width: '729px',
    padding: 0,
    backdrop: 'rgba(0,0,0,0.4)'
  })
}
